import React from 'react';

const ChannelPreview = () => (
  <div className="flex gap-3 items-center">
    <div className="w-10 h-10 bg-gray-200 rounded-full"></div>
    <div className="flex flex-col gap-2 flex-1">
      <div className="w-1/2  h-3 rounded-full bg-gradient-to-r from-gray-200 to-gray-white"></div>
      <div className="w-full h-3 rounded-full bg-gradient-to-r from-gray-200 to-gray-white"></div>
    </div>
  </div>
);

export const ChatPlaceholder = () => (
  <div
    className="bg-white rounded-xl flex h-[80vh]"
    style={{ maxWidth: '935px' }}
  >
    <div className="p-5 w-full md:w-1/3 h-full md:border-r border-gray-100 flex flex-col gap-4">
      {[...Array(10).keys()].map((index) => (
        <ChannelPreview key={index} />
      ))}
    </div>
  </div>
);
